import React from "react";

import classes from "./TopUp.module.css";

const Procced = (props) => {
  let procced = null;
  if (props.topUped) {
    procced = (
      <div className={classes.Procced+" mt-5"}>
        <h3> {props.topUped.data.description} </h3>
        <a href={props.topUped.data.redirectUrl}> Procced</a>
      </div>
    );
    return procced;
  }
};

export default Procced;
